import { render } from "./EgyProjects.vue?vue&type=template&id=17ea2f5f&scoped=true"
const script = {}

import "./EgyProjects.vue?vue&type=style&index=0&id=17ea2f5f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17ea2f5f"

export default script